import { FC } from "react";
import {Link, useLocation} from "react-router-dom";

const GuestTopHeader: FC = (): JSX.Element => {
  const location = useLocation();

  return (
    <div className="container container-full">
      <div className="row align-items-center flex-wrap flex-md-nowrap d-flex">
        <div className="col-md-4 col-12">
          <p className="m-0 text-primary">For US Healthcare Professionals</p>
        </div>
        {location.pathname !== "/enroll" &&
          <div className="d-flex gap-2 flex-wrap flex-md-nowrap">
            <div
                className="col-md-7 col-12 d-flex flex-wrap align-items-center justify-content-start justify-content-md-end">
              <p className="mb-0 text-primary h6">Register new patients and review patient status:</p>
            </div>
            <div className="col-md-1 col-12 bg-warning py-2 text-center" style={{minWidth: '70px'}}>
              <Link to="/users/sign_in" className="text-primary">Log In</Link>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default GuestTopHeader;
